'use client';

import React from 'react';
import { useTranslation } from './useTranslation';
import { Locale } from './i18n';

export function LanguageSwitcher() {
  const { locale, setLocale } = useTranslation();

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setLocale(e.target.value as Locale);
  };

  return (
    <select
      value={locale}
      onChange={handleChange}
      style={{
        padding: '8px 16px',
        borderRadius: 'var(--radius-md)',
        border: '1px solid var(--border-default)',
        backgroundColor: 'white',
        color: 'var(--text-primary)',
        fontSize: 'var(--text-sm)',
        fontWeight: '500',
        cursor: 'pointer',
        outline: 'none',
        transition: 'all 0.2s ease',
        boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = 'var(--color-primary-500)';
        e.currentTarget.style.boxShadow = '0 0 0 3px rgba(0, 102, 255, 0.1)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = 'var(--border-default)';
        e.currentTarget.style.boxShadow = '0 1px 2px rgba(0, 0, 0, 0.05)';
      }}
    >
      <option value="zh-CN">中文</option>
      <option value="en">English</option>
    </select>
  );
}

